import ScrollAnimation from 'react-animate-on-scroll';
import { FaLinkedin } from 'react-icons/fa'


function About() {
  return (
    <div className="row">
      <div className="offset-1 col-10">

        <div className="row">

          <div className="col-12 col-lg-4">
            <p>
              I have been working in IT since 2007.
            </p>
            <p>
              I began my career in support as an Application Engineer.
              I worked for 7 years in IT Support.
              Then in 2015 I decided to move into to Development
              to pursue my passion for coding and web development.
            </p>
            <p>
              Web Development has been my favorite aspect of working in IT.
              Being a Developer has allowed me to apply creative skills that I truly enjoy.
              I have also enjoyed many enriching collaborations.
            </p>
            <p>
              Along the way I combined my interests in art, music and gaming
              by working in Unity Game Engine doing tutorials and eventually building my own games.
              This allowed me to incorporate sound, music, graphics, and coding logic.
            </p>
          </div>

          <div className="col-12 col-lg-4 pb-4">
            <ScrollAnimation animateIn='flipInX' animateOnce={true}>
              <div className="profile-img-wrap mx-auto my-3 d-block">
                <img src={'images/profile-pic.jpg'} className='profile-img rounded-circle img-fluid shadow' alt='headshot' />
              </div>
            </ScrollAnimation>
          </div>

          <div className="col-12 col-lg-4">
            <p>
              In 2015, I completed a Web Development Certification at Delaware County Community College
              learning web fundamentals like HTML, CSS, PHP and Bootstrap.
              Shortly after completing the certification, I began working as a Software Developer in May 2016.
            </p>
            <p>
              In 2020, I completed the Front End and Mobile Development Certification at NuCamp Bootcamp,
              building projects in React and React Native to expand my front-end skills.
            </p>
            <p>
              From 2021 to 2023, I worked in consulting,
              contributing to various projects that utilized a wide range of technologies including AWS.
            </p>
            <p>
              Most recently, I worked for Killer Snails, an EdTech company.
              I found working on their projects and contributing to the educational aspects of their games very rewarding.
            </p>

          </div>
        </div>

        <div className="row">
          <div className="col-12 text-center mt-3">

            <a href="https://www.linkedin.com/in/johngilday/"
              target="_blank"
              rel="noreferrer"
              className="btn btn-dark mx-auto"
              style={{ width: '200px' }}
            >
              <span>
                <FaLinkedin />&nbsp;LinkedIn
              </span>
            </a>
          </div>
        </div>

      </div>
    </div >
  );
}

export default About;
